export const sharedTheme = {
  primary: '#FA715E',
}
